import { startOfMonth } from "date-fns";

export const isMonthWithinBounds = (
	year: number,
	monthIndex: number,
	minDate?: Date,
	maxDate?: Date,
): boolean => {
	const monthStart = new Date(year, monthIndex, 1);
	const afterMinimum =
		minDate === undefined || monthStart >= startOfMonth(minDate);
	const beforeMaximum =
		maxDate === undefined || monthStart <= startOfMonth(maxDate);

	return afterMinimum && beforeMaximum;
};
